import { Controller } from "@hotwired/stimulus";

// A "Print" button: data-controller="print" data-action="print#print"
export default class extends Controller<HTMLElement> {
  print(): void {
    window.print();
  }
}
